import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const ChangePasswordRoutes: RouteObject[] = [
  { path: ROUTES_PATH.changePassword, lazy: () => import('./dashboard') },
];
